module.exports = __webpack_public_path__ + "static/media/f2.5eaf637a.jpeg";